import React from "react";
import TitleDisplayerComponent from "../TitleDisplayer/titledisplayer";
import { useInView } from "react-intersection-observer";
import { useEffect } from "react";
import { useState } from "react";
import { Button } from "@mui/material";
import ProductModalComponent from "../Product-Modal/product-modal";
import useShoppingKartStore from "../../Stores/shoppingKartStore";
import useCotizadorStore from "../../Stores/cotizadorStore";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
// import { Button } from "@mui/base";

function TiendaOnline() {
  const { ref: beneficiosImg, inView: beneficiosImgIsVisible } = useInView({
    threshold: 0.9,
    initialInView: true,
  });
  const { ref: beneficiostxt, inView: beneficiosTxtIsVisible } = useInView({
    threshold: 0.9,
    initialInView: true,
  });

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  const [productList, setProductList] = useState([]);
  const [hovered, setHovered] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [product, setProduct] = useState({});
  const addToKart = useShoppingKartStore((state) => state.addToKart);
  const addToCotizador = useCotizadorStore((state) => state.addToCotizador);

  useEffect(() => {
    fetch("https://grupo-serdan-back-iplv-dev.fl0.io/api/products")
      .then((data) => data.json())
      .then((res) => {
        res.splice(5);
        console.log("ONLY 5");
        console.log(res);
        setProductList([...res]);
      });
  }, []);

  const closeModal = () => {
    setOpenModal(false);
  };

  const handleOpenModal = (prod) => {
    setProduct(prod);
    setOpenModal(true);
  };

  return (
    <>
      <div class="ContentBeneficios" style={{ marginTop: "50px" }}>
        <ProductModalComponent
          closeModal={closeModal}
          isOpen={openModal}
          product={product}
        />
        <TitleDisplayerComponent text="Tienda Online" color={"red"} />
        <div class="ContentWrapBeneficios">
          {productList.map((el, index) => (
            <div
              class="wrapTxtImgBeneficios"
              key={el._id}
              style={{ position: "relative" }}
              onMouseEnter={() => setHovered(index)}
              onMouseLeave={() => setHovered(null)}
            >
              <img
                ref={beneficiosImg}
                className={`ImgSizeBeneficios ${
                  beneficiosImgIsVisible ? "ImgSizeBeneficiosAnimated1" : ""
                }`}
                style={{ height: "220px", width: "220px", margin: "0" }}
                src={el.productImg}
                alt={"Image " + index}
              ></img>
              <div style={{ padding: "10px 0px", textAlign: "center" }}>
                <span
                  ref={beneficiostxt}
                  style={{ color: "gray", fontSize: "12px" }}
                  className={`imageLabel ${
                    beneficiosTxtIsVisible ? "imageLabelAnimated" : ""
                  }`}
                >
                  {el.tag?.filter((tag) => tag.tagType === "marca")[0]
                    ? el.tag?.filter((tag) => tag.tagType === "marca")[0]
                        .tagName
                    : ""}
                </span>{" "}
                <br />
                <span
                  ref={beneficiostxt}
                  style={{ color: "black", fontSize: "16px" }}
                  className={`imageLabel ${
                    beneficiosTxtIsVisible ? "imageLabelAnimated" : ""
                  }`}
                >
                  {el.name}
                </span>
                <br />
                <span
                  ref={beneficiostxt}
                  style={{ color: "black", fontSize: "16px" }}
                  className={`imageLabel ${
                    beneficiosTxtIsVisible ? "imageLabelAnimated" : ""
                  }`}
                >
                  <b>{formatter.format(Number(el.price))}</b>
                </span>
              </div>
              {hovered === index && (
                <div
                  style={{
                    position: "absolute",
                    bottom: 0,
                    width: "100%",
                    backgroundColor: "rgba(0,0,0,0.4)",
                  }}
                >
                  <Button
                    style={{
                      backgroundColor: "#65b32e",
                      margin: "5px 0px",
                      color: "white",
                    }}
                    onClick={() => handleOpenModal(el)}
                  >
                    Ver Ficha Técnica
                  </Button>
                  <br />
                  <Button
                    style={{
                      backgroundColor: "#1f3e92",
                      margin: "5px 0px",
                      color: "white",
                    }}
                    onClick={() => addToCotizador(el)}
                  >
                    Añadir a cotización
                  </Button>
                  <br />
                  <Button
                    style={{
                      backgroundColor: "#e51b20",
                      margin: "5px 0px",
                      color: "white",
                    }}
                    onClick={() => addToKart(el)}
                  >
                    Añadir a carrito
                  </Button>
                </div>
              )}
            </div>
          ))}
        </div>
        <Link to="/catalogo">
            <Button style={{margin: '15px auto'}} variant="contained">
              Ir a tienda online
            </Button>
          </Link>
      </div>
    </>
  );
}
export default TiendaOnline;
